import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { getCurrentAuthContext } from '../services/auth';
import { withdrawalService } from '../services/dashboardService';
import { normalizeWithdrawalPanelMode } from '../utils/parishWithdrawalPanel';

export type WithdrawalGlobalState = {
  enabled: boolean;
  suspended: boolean;
  message?: string;
};

export const useWithdrawalGlobalState = () => {
  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);
  const authContext = getCurrentAuthContext();
  const isMainParish = user?.parish?.isMainParish ?? false;
  const withdrawalPanelMode = normalizeWithdrawalPanelMode(user?.parish?.features?.withdrawalPanelMode);

  return useQuery({
    queryKey: ['withdrawalGlobalState'],
    enabled: Boolean(
      isAuthenticated &&
        authContext === 'parish' &&
        isMainParish &&
        user?.allowWithdrawalAccess !== false &&
        withdrawalPanelMode !== 'hidden'
    ),
    staleTime: 60_000, // evita refetch desnecessário
    retry: 0,
    queryFn: async (): Promise<WithdrawalGlobalState | null> => {
      const data = await withdrawalService.getWithdrawalEvents();
      return data.withdrawalGlobalState ?? null;
    },
  });
};

